// This file is part of Indico.UN.
// Copyright (C) 2019 - 2025 United Nations. All rights reserved.

(function(global) {
  'use strict';
  /*
   * Removes URL parameters
   * @param paramsToRemove - param array
   */
  global.removeURLParameters = function removeURLParameters(paramsToRemove) {
    const deleteRegex = new RegExp(paramsToRemove.join('=|') + '=')
    const params = location.search.slice(1).split('&')
    let search = []
    for (let i = 0; i < params.length; i++)
      if (deleteRegex.test(params[i]) === false) search.push(params[i])
    window.history.replaceState({}, document.title, location.pathname + (search.length ? '?' + search.join('&') : '') + location.hash)
  }
  global.checkDateAndDraw = function checkDateAndDraw(inputElement) {
    const dateStr = inputElement.value.trim();
    const regex = /^(\d{4})-(\d{2})-(\d{2})$/;
    const match = dateStr.match(regex);
    if (!match) {
      return;
    }
    const year = parseInt(match[1], 10);
    const month = parseInt(match[2], 10);
    const day = parseInt(match[3], 10);

    if (
      year < 1900 || year > 2100 ||
      month < 1 || month > 12 ||
      day < 1 || day > 31
    ) {
      return;
    }
    table.draw(false);
  }
})(window);
